import { render, staticRenderFns } from "./CoozzyLanguageIcon.vue?vue&type=template&id=7a362196&scoped=true"
import script from "./CoozzyLanguageIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyLanguageIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyLanguageIcon.vue?vue&type=style&index=0&id=7a362196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a362196",
  null
  
)

export default component.exports